import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { inject as controller } from "@ember/controller";
import DButton from "discourse/ui-kit/d-button";

function padStart(number) {
  return number.toString().padStart(2, "0");
}

function formatDate(date) {
  return `${date.getFullYear()}-${padStart(date.getMonth() + 1)}-${padStart(
    date.getDate(),
  )}`;
}

function buildLogsUrl(baseUrl, username, postCreationDate) {
  const postDate = new Date(postCreationDate);
  const dayBeforePostDate = new Date(postDate);
  dayBeforePostDate.setDate(postDate.getDate() - 1);
  const dayAfterPostDate = new Date(postDate);
  dayAfterPostDate.setDate(postDate.getDate() + 1);

  const logsUrl = new URL(baseUrl);
  logsUrl.searchParams.append("start", formatDate(dayBeforePostDate));
  logsUrl.searchParams.append("end", formatDate(dayAfterPostDate));
  logsUrl.searchParams.append("username", username);

  return logsUrl;
}

export default class WazeCopyLogsButton extends Component {
  @service siteSettings;
  @controller topic;

  @action
  openLogsUrl() {
    const logsBaseUrl = this.siteSettings.waze_logs_and_stats_domain;
    if (!logsBaseUrl) {
      return;
    }

    const firstPostInTopic = this.topic?.model?.postStream?.posts?.find(
      (post) => post.firstPost,
    );
    if (!firstPostInTopic?.username || !firstPostInTopic?.created_at) {
      return;
    }

    try {
      const logsUrl = buildLogsUrl(
        logsBaseUrl,
        firstPostInTopic.username,
        firstPostInTopic.created_at,
      );
      window.open(logsUrl);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Failed to build logs URL:", e);
    }
  }

  <template>
    <DButton
      ...attributes
      @action={{this.openLogsUrl}}
      @icon="w-doc"
      @title="waze.forms.open_logs_button.description"
    />
  </template>
}
